import classnames from 'classnames';
import type {
  ChangeEvent,
  ComponentProps,
  FocusEvent,
  KeyboardEvent,
  ReactNode,
  RefObject,
} from 'react';

import { css } from '@sorare/css';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconSearch } from '#src/atoms/icons/system/iconSearch.ts';
import { TextInput } from '#src/atoms/inputs/TextInput/index.tsx';

type Props = {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  placeholder?: string;
  className?: string;
  fullWidth?: boolean;
  withIcon?: boolean;
  inputRef?: RefObject<HTMLInputElement | null>;
  autoFocus?: boolean;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  onFocus?: (event: FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  endAdornment?: ReactNode;
  size?: ComponentProps<typeof TextInput>['size'];
  disabled?: boolean;
  error?: boolean;
  name?: string;
  maxLength?: number;
};

const stretched = css`
  width: 100%;
`;

const SearchIcon = () => {
  return <FontAwesomeIcon icon={iconSearch} />;
};

export const SearchInput = ({
  value,
  className,
  fullWidth = false,
  withIcon = false,
  endAdornment,
  inputRef,
  ...inputProps
}: Props) => {
  return (
    <TextInput
      value={value}
      className={classnames(className, { [stretched]: fullWidth })}
      inputRef={inputRef}
      autoCorrect="off"
      autoComplete="off"
      startAdornment={withIcon ? <SearchIcon /> : null}
      type="search"
      endAdornment={endAdornment}
      {...inputProps}
    />
  );
};

SearchInput.displayName = 'SearchInput';
